<template>
  <FAQ :class="$style.faq">
    <TheContent
      v-for="item of props.elem"
      :key="item.id"
      :elem="item"
    />
  </FAQ>
</template>

<script lang="ts" setup>
  import type { TContent } from '~/types/common';
  import type { PropType } from 'vue';
  import TheContent from '~/components/TheContent';
  import FAQ from '@devhacker/shared/components/blocks/FAQ.vue';

  const props = defineProps({
    elem: {
      type: Array as PropType<TContent[]>,
      required: true,
    },
  });
</script>

<style lang="scss" module>
  @use '@devhacker/shared/styles/breakpoints' as breakpoints;

  .faq {
    --faq-header-font: normal 20px/30px #{$secondFont};
    --faq-space-after-header: 16px;
    --faq-question-font: normal 18px/28px #{$secondFont};
    --faq-answer-font: 14px/20px #{$mainFont};
    --faq-background: #fbf8f8;
    --faq-border: 1px solid #e7e7e7;
    --faq-border-radius: 36px;
    --faq-space-between-blocks: 16px;
    --faq-space-after-question: 12px;
    --faq-padding: 24px;
    --faq-color: #000;
    --faq-space-above-button: 2px;
    margin: 24px 0;

    @include breakpoints.tablet {
      --faq-header-font: normal 26px/34px #{$secondFont};
      --faq-answer-font: 16px/24px #{$mainFont};
    }
  }
</style>
